import { FormGroup } from '@angular/forms';
import { Step2PartyUiHost } from './step2-party-actions.util';

/** Reconstruye selección de partes al volver al paso 2 con datos persistidos. */
export function hydrateStep2SelectedPartiesFromForm(
    form: FormGroup,
    host: Step2PartyUiHost,
): void {
    const sp = form.get('shipperPartyId')?.value as number | null;
    if (sp) {
        host.selectedShipper = {
            partyId: sp,
            name: (form.get('shipperName')?.value as string) ?? '',
            address: (form.get('shipperAddress')?.value as string) ?? '',
            email: form.get('shipperEmail')?.value as string | undefined,
            taxIdentificationNumber: form.get('shipperTaxIdentificationNumber')
                ?.value as string | undefined,
            contactName: form.get('shipperContactName')?.value as
                | string
                | undefined,
            phoneNumber: form.get('shipperPhoneNumber')?.value as
                | string
                | undefined,
            mobilePhoneNumber: form.get('shipperMobilePhoneNumber')?.value as
                | string
                | undefined,
        };
    } else {
        host.selectedShipper = null;
    }
}
